import Vue from 'vue'
import path from 'path'

// Import base css
import '../assets/css/main.css'

// Register components globally
const requireComponent = require.context('./', true, /[\w-]+\.vue$/)
requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName)
  const componentName =
    'Dr' +
    path
      // Remove directories from fileName
      .basename(fileName)
      // Remove the file extension from the end
      .replace(/\.\w+$/, '')
  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig)
})
